import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getFactor, addFactor, deleteFactor, updateFactor } from "../../redux/actions/factor.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess"
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs,  Divider } from 'antd';
import { logColumns, factorColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';

const { TabPane } = Tabs;

export default function Factor({ token }) {
    TabTitle("Factor")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const factorNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm(); 
    const [factorObj, setfactorObj] = useState(null);
    const dispatch = useDispatch();
    const { factor,  log, userRights } = useSelector(state => state)
    // const stateData = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [factorMethodTypeName, setfactorMethodTypeName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

 


    useEffect(() => {
        dispatch(getFactor(token, menuId));
        // dispatch(getLog(token));
        dispatch(getLog(token, { admin_factor: "admin_factor"}))
      }, [token]);
    

    // useEffect(() => {
    //     dispatch(getDefaultCompany(token));
    // }, [token])


    useEffect(() => {
        dispatch(getFactor(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (factorObj) {
            setFormState('view')
            form.setFieldsValue({
                id: factorObj.factor_id,
                factor: factorObj.factor_name,
                active: factorObj.is_active
            });
            // setDescription(factorObj.bergan_billing_name)
            setfactorMethodTypeName(factorObj.factor_name)
            setCheck(factorObj.is_active)
            dispatch(getCompanyAccess(token, factorObj.factor_id, menuId))

        }
    }, [factorObj]);

    useEffect(() => {
        if (factorMethodTypeName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [factorMethodTypeName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            // data: { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }
            dispatch(getLog(token, { admin_factor: "admin_factor"}))
        }
    }


    const formSave =async () => {
        if (formState === "add") {
            dispatch(addFactor(token, { factorMethodTypeName, check }, menuId)).then((res) => {

                if (res.type === "ADD_FACTOR_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_FACTOR_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    notification("success", "Factor Created", "Factor created successfully!");
                    form.setFieldsValue({
                        factor: ""
                    })
                    setFormState("")
                    // setCheck(false)
                    setfactorMethodTypeName("")
                    setfactorObj(null)
                }
                dispatch(getFactor(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateFactor(token, { factorMethodTypeName, check }, factorObj.factor_id)).then((res) => {
                if (res.type === "UPDATE_FACTOR_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_FACTOR_SUCCESS") {
                    notification("success", "Factor Updated", "Record updated successfully")
                }
                dispatch(getFactor(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (factorObj) {
            dispatch(deleteFactor(token, factorObj.factor_id)).then((res) => {
                if (res.type === "DELETE_FACTOR_SUCCESS") {
                    notification("success", "Factor Deleted", "Factor deleted successfully!");
                }
                if (res.type === "DELETE_FACTOR_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    factor: ""
                })
                // setCheck(false)
                setfactorMethodTypeName("")
                setfactorObj(null)
                setFormState('')
                dispatch(getFactor(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            factorNameInput.current.focus();
            form.setFieldsValue({
                factor: ""
            })
            setCheck(true)
            setfactorMethodTypeName("")
            setfactorObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Factor"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="factor" factorObj={setfactorObj} scrollX={"20rem"} scroll={602} perPage={25} source={factor?.payload?.data} col={factorColumns} paginate load={factor?.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 12 }}
                                        >
                                             <div className='customRow styleFormUpper ' >
                                            {factorObj !== null && !(formState === "add") &&
                                            <div className='customCols slc'>
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    initialValue={form.getFieldValue().id}
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                >
                                                    <Input  size='small' className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                                </div>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Factor"
                                                name="factor"
                                                labelCol={{ span: 5 }}
                                                wrapperCol={{ span: 14 }}
                                                initialValue={form.getFieldValue().factor}
                                            >

                                                <Input  size='small' disabled={!(formState === "add" || formState === "edit")} ref={factorNameInput} onChange={(e) => setfactorMethodTypeName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                labelCol={{ span: 5 }}
                                                wrapperCol={{ span: 14 }}
                                                name="active"
                                            >
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
                                        </Form>
                                
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                         
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                   
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}